/* eslint-disable no-mixed-operators */
/* eslint-disable no-nested-ternary */
(function () {
    'use strict';

    angular
        .module('ib-checkin-services-module')
        .factory('FlightsPassengersUtils', FlightsPassengersUtils);

    FlightsPassengersUtils.$inject = ['$filter', 'CheckinAppConstants', 'UtilsService', 'localStorageService', '$sce', 'ModalService', '$timeout'];
    function FlightsPassengersUtils ($filter, CheckinAppConstants, UtilsService, localStorageService, $sce, ModalService, $timeout) {
        const service = {
            getGeneralSegmentInfo: getGeneralSegmentInfo,
            getDetailedSegmentInfo: getDetailedSegmentInfo,
            getPassengerInfo: getPassengerInfo,
            getAvailablePassengers: getAvailablePassengers,
            getPassengersUpdateInformation: getPassengersUpdateInformation,
            getSegmentsUpdateInformation: getSegmentsUpdateInformation,
            getAcceptUpdateInformation: getAcceptUpdateInformation,
            updateSelectedSegments: updateSelectedSegments,
            updateSelectedPassengers: updateSelectedPassengers,
            getPassengerAdditionalInfo: getPassengerAdditionalInfo,
            getPassengerEmergencyInfo: getPassengerEmergencyInfo,
            initModelApisUsTracing: initModelApisUsTracing,
            checkExistAPIsUsTracing: checkExistAPIsUsTracing,
            openUsPrivacyActStatementModal: openUsPrivacyActStatementModal,
            getReasonNoItemInhibition: getReasonNoItemInhibition
        };

        return service;

        ////////////////

        function getGeneralSegmentInfo (generalPassengersInfo, segmentInfo, type) {
            let passengersIndex;
            const passengersInfo = segmentInfo.passengers || [], segmentsError = [], auxWhatToDoShuttle = { flyNow: false, mmbAvailable: false, hasSeat: false, noShow: false };
            let checked = 0, available = 0, notAvailable = 0, notAllowed = 0, passengerStatus, availablePassengers = 0, passengerStatusObject = {}, passengerInfo = {};
            const returnedInfoSegment = {
                segmentStatus: '',
                segmentStatusReason: '',
                passengersStatus: [],
                airCheck: {
                    status: false,
                    url: ''
                }
            };

            for (passengersIndex = 0; passengersIndex < passengersInfo.length; passengersIndex++) {
                passengerInfo = passengersInfo[passengersIndex];
                passengerStatusObject = {
                    id: '',
                    status: '',
                    isSelected: true,
                    name: '',
                    surname: '',
                    airCheckDocumentationRequired: false,
                    items: [],
                    inhibitBoardingCard: {
                        reason: []
                    }
                };

                passengerStatusObject.items = (Array.isArray(passengerInfo.items)) ? passengerInfo.items : [];

                passengerStatusObject.airCheckDocumentationRequired = passengerInfo?.airCheckDocumentationRequired || false;

                if (Array.isArray(passengerInfo.inhibitBoardingCard)) {
                    passengerStatusObject.inhibitBoardingCard.reason = passengerInfo.inhibitBoardingCard;

                    const newReason = getReasonNoItemInhibition(passengerStatusObject.inhibitBoardingCard.reason);
                    if (newReason) {
                        passengerStatusObject.items.push(newReason);
                    }
                    passengerStatusObject.airCheckDocumentationRequired = passengerInfo?.airCheckDocumentationRequired || false;
                }

                if (CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.CHECKED.indexOf(passengerInfo.status.code) !== -1) {
                    checked++;
                    availablePassengers++;
                } else if (CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.AVAILABLE.indexOf(passengerInfo.status.code) !== -1) {
                    available++;
                    availablePassengers++;
                } else if (CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.NOT_AVAILABLE.indexOf(passengerInfo.status.code) !== -1) {
                    passengerStatus = getGeneralPassengerStatus(generalPassengersInfo, passengerInfo.id);
                    segmentsError.push(passengerInfo.status);
                    if (passengerStatus.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.ALLOWED) {
                        notAvailable++;
                    } else {
                        notAllowed++;
                    }
                }

                passengerStatusObject.id = passengerInfo.id;
                passengerStatusObject.status = passengerInfo.status.code;
                passengerStatusObject.name = generalPassengersInfo[passengersIndex].name;
                passengerStatusObject.surname = generalPassengersInfo[passengersIndex].surname;
                passengerStatusObject.flyNow = passengerInfo.flyNow;
                returnedInfoSegment.passengersStatus.push(passengerStatusObject);

                auxWhatToDoShuttle.flyNow = auxWhatToDoShuttle.flyNow || passengerInfo.flyNow;
                auxWhatToDoShuttle.mmbAvailable = auxWhatToDoShuttle.mmbAvailable || passengerInfo.mmbAvailable;
                auxWhatToDoShuttle.hasSeat = auxWhatToDoShuttle.hasSeat || passengerInfo.seat !== null;
                auxWhatToDoShuttle.noShow = auxWhatToDoShuttle.noShow || passengerInfo.noShow;
            }

            if (segmentInfo?.airCheck) {
                returnedInfoSegment.airCheck.status = segmentInfo.airCheck;
                returnedInfoSegment.airCheck.url = $filter('LinksFilter')('MANAGE_MY_BOOKING_LINK', CheckinAppConstants.lang) + '#!/chktrp?pnr=' + localStorageService.get('PNR') + '&surname=' + localStorageService.get('checkinSurname') + '&quadrigam=' + CheckinAppConstants.QUADRIGAM.MMB_YOUR_DOCUMENTS;
            }

            if (segmentInfo.type === CheckinAppConstants.SHUTTLE_SEGMENTS_TYPES.OPEN) {
                returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.AVAILABLE;
            } else if (notAvailable > 0 || notAllowed === passengersInfo.length) {
                if (auxWhatToDoShuttle.flyNow || auxWhatToDoShuttle.mmbAvailable) {
                    returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.SELECTABLE;
                } else {
                    returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.NOT_AVAILABLE;
                }
            } else if (checked === availablePassengers) {
                returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.CHECKED;
            } else if (available !== 0) {
                returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.AVAILABLE;
            } else {
                returnedInfoSegment.segmentStatus = CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.NOT_AVAILABLE;
            }
            if (segmentsError.length > 0) {
                returnedInfoSegment.segmentStatusReason = segmentsError[0].message;
            }
            if (type === CheckinAppConstants.FLIGHT_TYPES.SHUTTLE) {
                returnedInfoSegment.whatToDo = generateWhatToDoShuttleBlocks(auxWhatToDoShuttle, segmentInfo, returnedInfoSegment.segmentStatus);
            }

            return returnedInfoSegment;

            function getGeneralPassengerStatus (passengersInformation, passengerId) {
                let pIndex = 0, pFound = false, pStatus = CheckinAppConstants.GENERAL_PASSENGERS_STATUS.NOT_ALLOWED;
                while (!pFound && pIndex < passengersInformation.length) {
                    if (passengerId === passengersInformation[pIndex].id) {
                        pFound = true;
                        pStatus = angular.copy(passengersInformation[pIndex].status);
                    }
                    pIndex++;
                }
                return pStatus;
            }
        }

        function getDetailedSegmentInfo (segmentInfo, segmentStatus) {
            const segmentDetailedInfo = {
                id: segmentInfo.id,
                departure: {
                    cityDescription: '',
                    cityCode: '',
                    airportDescription: segmentInfo.departure && segmentInfo.departure.airport ? segmentInfo.departure.airport.description : '',
                    airportCode: segmentInfo.departure && segmentInfo.departure.airport ? segmentInfo.departure.airport.code : '',
                    terminal: segmentInfo.departure ? segmentInfo.departure.terminal : '',
                    originalDate: segmentInfo.departure.date,
                    date: segmentInfo.departure && segmentInfo.departure.date ? $filter('DateFormatFilter')(segmentInfo.departure.date.split(' ')[0]) : '',
                    hour: segmentInfo.departure && segmentInfo.departure.date ? segmentInfo.departure.date.split(' ')[1] : ''
                },
                arrival: {
                    cityDescription: '',
                    cityCode: '',
                    airportDescription: segmentInfo.arrival && segmentInfo.arrival.airport ? segmentInfo.arrival.airport.description : '',
                    airportCode: segmentInfo.arrival && segmentInfo.arrival.airport ? segmentInfo.arrival.airport.code : '',
                    terminal: segmentInfo.arrival ? segmentInfo.arrival.terminal : '',
                    originalDate: segmentInfo.arrival.date,
                    date: segmentInfo.arrival && segmentInfo.arrival.date ? $filter('DateFormatFilter')(segmentInfo.arrival.date.split(' ')[0]) : '',
                    hour: segmentInfo.arrival && segmentInfo.arrival.date ? segmentInfo.arrival.date.split(' ')[1] : ''
                },
                cabinClass: segmentInfo.cabinClass,
                type: segmentInfo.typeOfTransport,
                detailedType: segmentInfo.type,
                flown: segmentInfo.flown,
                airlineName: segmentInfo.operatingFlightNumber && segmentInfo.operatingFlightNumber.company && segmentInfo.operatingFlightNumber.company.description ? segmentInfo.operatingFlightNumber.company.description : segmentInfo.marketingFlightNumber && segmentInfo.marketingFlightNumber.company && segmentInfo.marketingFlightNumber.company.description ? segmentInfo.marketingFlightNumber.company.description : '',
                airlineLogo: segmentInfo.operatingFlightNumber && segmentInfo.operatingFlightNumber.company && segmentInfo.operatingFlightNumber.company.code ? segmentStatus === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.NOT_AVAILABLE ? UtilsService.getAirlineLogos(segmentInfo.operatingFlightNumber.company.code).companyDisabledURL : UtilsService.getAirlineLogos(segmentInfo.operatingFlightNumber.company.code).companyURL : segmentStatus === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.NOT_AVAILABLE ? UtilsService.getAirlineLogos(segmentInfo.marketingFlightNumber.company.code).companyDisabledURL : UtilsService.getAirlineLogos(segmentInfo.marketingFlightNumber.company.code).companyURL,
                flightCode: segmentInfo.operatingFlightNumber && segmentInfo.operatingFlightNumber.company && segmentInfo.operatingFlightNumber.company.code ? segmentInfo.operatingFlightNumber.company.code : segmentInfo.marketingFlightNumber.company.code,
                flightNumber: segmentInfo.marketingFlightNumber && segmentInfo.marketingFlightNumber.number && segmentInfo.marketingFlightNumber.company && segmentInfo.marketingFlightNumber.company.code ? segmentInfo.marketingFlightNumber.company.code + segmentInfo.marketingFlightNumber.number : segmentInfo.operatingFlightNumber.company.code + segmentInfo.operatingFlightNumber.number,
                operatedBy: null
            };

            if (segmentInfo.operatingFlightNumber && segmentInfo.operatingFlightNumber.company && (segmentInfo.marketingFlightNumber === null && segmentInfo.operatingFlightNumber.company.description ||
                segmentInfo.marketingFlightNumber && segmentInfo.marketingFlightNumber.company && segmentInfo.operatingFlightNumber.company.code !== segmentInfo.marketingFlightNumber.company.code)) {
                segmentDetailedInfo.operatedBy = segmentInfo.operatingFlightNumber.company.description;
            }

            return segmentDetailedInfo;
        }

        function getPassengerInfo (passenger, areAllSegmentChecked, additionalInfo, emergencyServiceData, defaultPrefix, open) {
            const bookingInfo = localStorageService.get('bookingInfo');
            let passengerAdditionalInfo, emergencyInfo, passengersIndex, emergencyIndex = 0, emergencyFound = false, opationalFFActive = false, opationalFFIndex = 0, isOpenPA = false, sIndex, passengerStatusFlight = '';
            const isIncludes = (itemSearch, isOptionalInformation = false) => {
                const searchInfo = isOptionalInformation ? passenger.optionalInformation : passenger.requiredInformation;
                if (itemSearch === CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) {
                    return Array.isArray(searchInfo) && searchInfo.includes(itemSearch) || searchInfo.includes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.TIMATIC);
                }

                return Array.isArray(searchInfo) && searchInfo.includes(itemSearch);
            };

            if (bookingInfo.airShuttleSegments && bookingInfo.airShuttleSegments.length > 0) {
                isOpenPA = 0;
                for (sIndex = 0; sIndex < bookingInfo.airShuttleSegments.length; sIndex++) {
                    if (bookingInfo.airShuttleSegments[sIndex].type === CheckinAppConstants.SHUTTLE_SEGMENTS_TYPES.OPEN) {
                        isOpenPA++;
                    }
                }
                isOpenPA = isOpenPA === bookingInfo.airShuttleSegments.length;
            }
            for (passengersIndex = 0; passengersIndex < additionalInfo.length; passengersIndex++) {
                if (additionalInfo[passengersIndex].id === passenger.id) {
                    passengerAdditionalInfo = additionalInfo[passengersIndex].disruptionContact;
                }
            }
            while (!emergencyFound && emergencyIndex < emergencyServiceData.length) {
                if (emergencyServiceData[emergencyIndex] && emergencyServiceData[emergencyIndex].emergencyContact !== null && passenger.id === emergencyServiceData[emergencyIndex].passengerId) {
                    emergencyInfo = emergencyServiceData[emergencyIndex].emergencyContact;
                    emergencyFound = true;
                }
                emergencyIndex++;
            }
            if(bookingInfo && bookingInfo.outwardSegments && bookingInfo.outwardSegments[0] && bookingInfo.outwardSegments[0] && bookingInfo.outwardSegments[0].passengers && bookingInfo.outwardSegments[0].passengers[0] && bookingInfo.outwardSegments[0].passengers[0].status) {
                passengerStatusFlight = bookingInfo.outwardSegments[0].passengers[0].status.code;
            }
            const returnedPasInfo = {
                id: passenger.id,
                type: passenger.type,
                pasStatus: getPassengerStatus(passenger, areAllSegmentChecked),
                requiresApis: isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) || (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API, true) && passengerStatusFlight === 'CHECKABLE') ,
                fieldStatus: {
                    contactData: {
                        available: !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) && (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA, true)),
                        show: !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) && (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA, true)),
                        mandatory: isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA)
                    },
                    emergencyData: {
                        available: !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) && (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY, true) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA, true)),
                        show: !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) && (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY, true) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA, true)),
                        mandatory: isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA)
                    },
                    gender: {
                        show: !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API) && (isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.GENDER) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.GENDER, true) || passenger.type === CheckinAppConstants.PASSENGERS_TYPES.CHILD),
                        mandatory: isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.GENDER)
                    },
                    frequentFlyer: {
                        show: (isOpenPA || passenger.frequentFlyer || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FREQUENT_FLYER) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FREQUENT_FLYER, true) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FF) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FF, true)) && !isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.API),
                        mandatory: isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FREQUENT_FLYER) || isIncludes(CheckinAppConstants.PASSENGER_DATA_OPTIONS.FF),
                        isOpenPA: isOpenPA
                    }
                },
                requiredInformation: passenger.requiredInformation,
                isSelected: false,
                isOpen: open,
                name: passenger.name,
                surname: passenger.surname,
                gender: passenger.gender ? passenger.gender : 'MALE',
                infant: passenger.infant,
                contactData: {
                    denyNewsLetter: false,
                    phone: { countryCode: defaultPrefix },
                    emergency: { phone: { countryCode: defaultPrefix } }
                },
                initialData: {
                    contact: {},
                    emergency: {}
                },
                inhibitBoardingCard: {
                    status: false,
                    reason: [],
                    url: ''
                }
            };

            while (!opationalFFActive && opationalFFIndex < passenger.optionalInformation.length) {
                if (passenger.optionalInformation[opationalFFIndex] === CheckinAppConstants.PASSENGER_DATA_OPTIONS.FREQUENT_FLYER) {
                    opationalFFActive = true;
                }
                opationalFFIndex++;
            }

            //returnedPasInfo['frequentFlyer'] = { 'info': passenger.frequentFlyer || { 'number': '', 'iataCompanyCode': '' }, 'enabled': !passenger.frequentFlyer || passenger.frequentFlyer && (passenger.frequentFlyer.number == null || !passenger.frequentFlyer.iataCompanyCode == null) };
            returnedPasInfo.frequentFlyer = { info: passenger.frequentFlyer || { number: '', iataCompanyCode: '' }, enabled: opationalFFActive };

            if (passengerAdditionalInfo) {
                returnedPasInfo.language = passengerAdditionalInfo.language || CheckinAppConstants.lang;
                returnedPasInfo.contactData.phone = {
                    countryCode: passengerAdditionalInfo?.phone?.countryCode?.code ?? defaultPrefix,
                    number: passengerAdditionalInfo?.phone?.number ?? ''
                };
                returnedPasInfo.contactData.email = passengerAdditionalInfo.email;
            }

            if (emergencyInfo) {
                returnedPasInfo.contactData.emergency = {
                    phone: {
                        countryCode: emergencyInfo?.phone?.countryCode?.code ?? defaultPrefix,
                        number: emergencyInfo?.phone?.number ?? ''
                    },
                    name: emergencyInfo.name
                };
            }
            returnedPasInfo.initialData.contact = {
                gender: angular.copy(returnedPasInfo.gender),
                phone: angular.copy(returnedPasInfo.contactData.phone),
                email: angular.copy(returnedPasInfo.contactData.email),
                frequentFlyer: angular.copy(returnedPasInfo.frequentFlyer)
            };
            returnedPasInfo.initialData.emergency = {
                name: angular.copy(returnedPasInfo.contactData.emergency.name),
                phone: angular.copy(returnedPasInfo.contactData.emergency.phone)
            };
            returnedPasInfo.contactData.available = returnedPasInfo.pasStatus.available;
            return returnedPasInfo;

            function getPassengerStatus (passenger, allSegmentChecked) {
                let available = false, isChecked = false, reason = null;
                available = isOpenPA ? isOpenPA : passenger.status.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.ALLOWED;
                if(isOpenPA && passenger.status.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.NOT_ALLOWED) {
                    available = false;
                }
                isChecked = available && allSegmentChecked;
                if (!available) {
                    reason = getPassengerStatusReason(passenger.status);
                }
                const isStatusNotAllowed = passenger.status.code === CheckinAppConstants.GENERAL_PASSENGERS_STATUS.NOT_ALLOWED;
                const isReasonEsta = passenger.status.reason && (passenger.status.reason.code.includes('ESTA_CONSTRAINTS') || passenger.status.reason.code.includes('EES_CONSTRAINTS'));
                const isApiEsta =  (isStatusNotAllowed && isReasonEsta) || existPassengersApisDocs(passenger.id);
                if (isApiEsta) {
                    UtilsService.updateApiEsta({ showTextEsta: true });
                }
                return {
                    available: available,
                    isChecked: isChecked,
                    reason: reason,
                    isApiEsta: isApiEsta
                };
            }
        }

        function existPassengersApisDocs (id) {
            const passengersApisDocs = localStorageService.get('passengersApisDocs') || [];
            return passengersApisDocs.includes(id);
        }

        /**
         * Return array with passengers available (Checked || Available )
         * @param {Object} bookingData Information of booking
         */
        function getAvailablePassengers (bookingData) {
            const segments = bookingData.outwardSegments.concat(bookingData.returnSegments || [], bookingData.airShuttleSegments || []);
            const availablePassengerIds = [];
            let i, j, maxSegments, maxPassengers, statusCode;
            for (i = 0, maxSegments = segments.length; i < maxSegments; i++) {
                for (j = 0, maxPassengers = segments[i].passengers.length; j < maxPassengers; j++) {
                    statusCode = segments[i].passengers[j].status.code;
                    if (isValidPassengerStatus(statusCode) && availablePassengerIds.indexOf(segments[i].passengers[j].id) === -1) {
                        availablePassengerIds.push(segments[i].passengers[j].id);
                    }
                }
            }
            return availablePassengerIds;
        }


        /**
         * Return array of passenger with additional information option
         * @param {Object} bookingData Information of booking
         * @return {Array} Array with ids of passengers
         */
        function getPassengerAdditionalInfo (bookingData) {
            const passengers = bookingData.passengers, availablePassengerIds = [];
            angular.forEach(passengers, (pas) => {
                if (checkInfo(pas, CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA)) {
                    availablePassengerIds.push(pas.id);
                }
            });

            return availablePassengerIds;
        }

        /**
         * Return array of passenger with emergency information
         * @param {Object} bookingData Information of booking
         * @return {Array} Array with ids of passengers with emergency info op
         */
        function getPassengerEmergencyInfo (bookingData) {
            const passengers = bookingData.passengers, availablePassengerIds = [];
            angular.forEach(passengers, (passenger) => {
                if (checkInfo(passenger, CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA)) {
                    availablePassengerIds.push(passenger.id);
                }
            });

            return availablePassengerIds;
        }

        /**
         * Check if passenger have the required information or required information and return
         * @param {Obj} passenger
         * @param {String} key
         * @returns {boolean} TRUE if passenger have key
         */
        function checkInfo (passenger, key) {
            return passenger.optionalInformation.indexOf(key) !== -1 || passenger.requiredInformation.indexOf(key) !== -1;
        }

        /**
         * Check if status is checked or available
         * @param {String} pasStatus Status of passenger
         */
        function isValidPassengerStatus (pasStatus) {
            return CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.CHECKED.indexOf(pasStatus) || CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.AVAILABLE.indexOf(pasStatus);
        }

        function generateWhatToDoShuttleBlocks (whatToDoStatus, segmentInfo, status) {
            const returnedShuttleBlocks = { active: false, options: [], selectedBlock: {} };
            const flightConfirmationNeedsCheckin = localStorageService.get('flightConfirmationNeedsCheckin') || [];
            if (segmentInfo.type === CheckinAppConstants.SHUTTLE_SEGMENTS_TYPES.CONFIRMED && !segmentInfo.flown) {
                if (status === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.AVAILABLE || flightConfirmationNeedsCheckin.indexOf(segmentInfo.id) !== -1) {
                    returnedShuttleBlocks.options.push({ id: CheckinAppConstants.SHUTTLE_WHAT_TO_DO_BLOCKS.CHECK_IN, description: 'IBCOAC_PA_WHAT_TO_DO_CHECKIN', nextStep: CheckinAppConstants.SHUTTLE_NEXT_STEPS.SEATS_MAP, icon: 'icon-checking_online' });
                } else if (status === CheckinAppConstants.FLIGHT_PASSENGERS_STATUS.CHECKED) {
                    if(!localStorageService.get('bookingInfo')?.ancillariesDisabled) returnedShuttleBlocks.options.push({ id: CheckinAppConstants.SHUTTLE_WHAT_TO_DO_BLOCKS.SEAT, description: 'IBCOAC_PA_WHAT_TO_DO_SEAT', nextStep: CheckinAppConstants.SHUTTLE_NEXT_STEPS.SEATS_MAP, icon: 'icon-asiento' });
                    returnedShuttleBlocks.options.push({ id: CheckinAppConstants.SHUTTLE_WHAT_TO_DO_BLOCKS.BOARDING_CARD, description: 'IBCOAC_PA_WHAT_TO_DO_BOARDING', nextStep: CheckinAppConstants.SHUTTLE_NEXT_STEPS.BOARDING_CARDS, icon: 'icon-imprimir' });
                }
            }
            if (whatToDoStatus.flyNow) {
                returnedShuttleBlocks.options.push({ id: CheckinAppConstants.SHUTTLE_WHAT_TO_DO_BLOCKS.MODIFY_SEGMENT, description: 'IBCOAC_PA_WHAT_TO_DO_MODIFY', nextStep: CheckinAppConstants.SHUTTLE_NEXT_STEPS.FLY_NOW, icon: 'icon-cambios_y_reembolsos' });
            } else if (whatToDoStatus.mmbAvailable) {
                returnedShuttleBlocks.options.push({ id: CheckinAppConstants.SHUTTLE_WHAT_TO_DO_BLOCKS.MODIFY_SEGMENT, description: 'IBCOAC_PA_WHAT_TO_DO_MODIFY', nextStep: CheckinAppConstants.SHUTTLE_NEXT_STEPS.GDR, icon: 'icon-cambios_y_reembolsos' });
            }
            if (returnedShuttleBlocks.options.length === 1) {
                returnedShuttleBlocks.selectedBlock = returnedShuttleBlocks.options[0];
            }
            returnedShuttleBlocks.active = returnedShuttleBlocks.options.length > 0;

            return returnedShuttleBlocks;
        }

        function getPassengersUpdateInformation (passengersInfo, useForAllInfo, selectedShuttleSegmentInfo) {
            const passengersData = [];
            const returnPasUpdateInfo = {
                regularPassengersIds: [], passengersApisIds: [], passengersSelected: [],
                newsLetterInfo: { info: [] }, additionalInfo: { needsUpdate: false, info: [], isMandatory: false }, emergencyInfo: { needsUpdate: false, info: [], isMandatory: false }
            };
            const shuttleSegmentType = (angular.isObject(selectedShuttleSegmentInfo) && angular.isString(selectedShuttleSegmentInfo.detailedType)) ? selectedShuttleSegmentInfo.detailedType : (angular.isObject(selectedShuttleSegmentInfo) && angular.isString(selectedShuttleSegmentInfo.type)) ? selectedShuttleSegmentInfo.type : '';
            let pasIndex, additionalInfo, emergencyInfo, additionalInfoForAll, emergencyInfoForAll, newsLetterInfo, updateAllContactData = false, updateAllEmergencyData = false;

            updateAllContactData = checkAdditionalInfo(passengersInfo);
            updateAllEmergencyData = checkEmergencyInfo(passengersInfo);

            for (pasIndex = 0; pasIndex < passengersInfo.length; pasIndex++) {
                passengersData.push({ id: passengersInfo[pasIndex].id + '', email: passengersInfo[pasIndex].contactData && passengersInfo[pasIndex].contactData.email ? passengersInfo[pasIndex].contactData.email : '', phone: passengersInfo[pasIndex].contactData && passengersInfo[pasIndex].contactData.phone ? passengersInfo[pasIndex].contactData.phone.number : '' });
                if (passengersInfo[pasIndex].isSelected) {
                    if (!passengersInfo[pasIndex].requiresApis) {
                        additionalInfo = getAdditionalInfo(passengersInfo[pasIndex], useForAllInfo.additionalInfoUseForAllCheck.status, updateAllContactData);
                        emergencyInfo = getEmergencyInfo(passengersInfo[pasIndex], useForAllInfo.emergencyDataUseForAllCheck.status, updateAllEmergencyData);
                        if (useForAllInfo.additionalInfoUseForAllCheck.showId === passengersInfo[pasIndex].id && useForAllInfo.additionalInfoUseForAllCheck.status) {
                            additionalInfoForAll = angular.copy(additionalInfo);
                        }
                        if (useForAllInfo.emergencyDataUseForAllCheck.showId === passengersInfo[pasIndex].id && useForAllInfo.emergencyDataUseForAllCheck.status) {
                            emergencyInfoForAll = angular.copy(emergencyInfo);
                        }
                        if (additionalInfoForAll || additionalInfo) {
                            if (additionalInfoForAll) {
                                additionalInfoForAll.gender = passengersInfo[pasIndex].gender;
                                additionalInfoForAll.id = passengersInfo[pasIndex].id;
                                if (additionalInfoForAll.frequentFlyer && passengersInfo[pasIndex].frequentFlyer.info && passengersInfo[pasIndex].frequentFlyer.info.number !== '' && passengersInfo[pasIndex].frequentFlyer.info.iataCompanyCode !== '') {
                                    additionalInfoForAll.frequentFlyer = passengersInfo[pasIndex].frequentFlyer.info;
                                } else {
                                    delete additionalInfoForAll.frequentFlyer;
                                }
                            }
                            if (((additionalInfoForAll && additionalInfoForAll.disruptionContact && additionalInfoForAll.disruptionContact.email) || (additionalInfo && additionalInfo.disruptionContact && additionalInfo.disruptionContact.email)) || (additionalInfoForAll && additionalInfoForAll.disruptionContact && additionalInfoForAll.disruptionContact.phone || additionalInfo && additionalInfo.disruptionContact && additionalInfo.disruptionContact.phone)) {
                                passengersData.push({ id: passengersInfo[pasIndex].id + '', email: additionalInfoForAll && additionalInfoForAll.disruptionContact && additionalInfoForAll.disruptionContact.email ? additionalInfoForAll.disruptionContact.email : additionalInfo && additionalInfo.disruptionContact && additionalInfo.disruptionContact.email ? additionalInfo.disruptionContact.email : '', phone: additionalInfoForAll && additionalInfoForAll.disruptionContact && additionalInfoForAll.disruptionContact.phone ? additionalInfoForAll.disruptionContact.phone.number : additionalInfo && additionalInfo.disruptionContact && additionalInfo.disruptionContact.phone ? additionalInfo.disruptionContact.phone.number : '' });
                            }

                            returnPasUpdateInfo.additionalInfo.isMandatory = passengersInfo[pasIndex].requiredInformation.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.CONTACT_DATA) !== -1;
                            returnPasUpdateInfo.additionalInfo.info.push(angular.copy(additionalInfoForAll) || additionalInfo);
                        }
                        if (emergencyInfoForAll || emergencyInfo) {
                            if (emergencyInfoForAll) {
                                emergencyInfoForAll.id = passengersInfo[pasIndex].id;
                            }

                            returnPasUpdateInfo.emergencyInfo.isMandatory = passengersInfo[pasIndex].requiredInformation.indexOf(CheckinAppConstants.PASSENGER_DATA_OPTIONS.EMERGENCY_DATA) !== -1;
                            returnPasUpdateInfo.emergencyInfo.info.push(angular.copy(emergencyInfoForAll) || emergencyInfo);
                        }
                        newsLetterInfo = getNewsLettersInfo(passengersInfo[pasIndex]);
                        if (newsLetterInfo) {
                            returnPasUpdateInfo.newsLetterInfo.info.push(newsLetterInfo);
                        }
                        returnPasUpdateInfo.regularPassengersIds.push(parseInt(passengersInfo[pasIndex].id));
                    } else {
                        returnPasUpdateInfo.passengersApisIds.push(parseInt(passengersInfo[pasIndex].id));
                    }
                } else if (selectedShuttleSegmentInfo && CheckinAppConstants.FLIGHT_PASSENGERS_STATUS_LIST.SHUTTLE.indexOf(shuttleSegmentType) !== -1) {
                    returnPasUpdateInfo.regularPassengersIds.push(parseInt(passengersInfo[pasIndex].id));
                }
                localStorageService.set('passengersContactData', passengersData);
            }
            returnPasUpdateInfo.additionalInfo.needsUpdate = returnPasUpdateInfo.additionalInfo.info.length > 0;
            returnPasUpdateInfo.emergencyInfo.needsUpdate = (updateAllEmergencyData && returnPasUpdateInfo.emergencyInfo.info.length > 0);
            returnPasUpdateInfo.passengersSelected = returnPasUpdateInfo.regularPassengersIds.concat(returnPasUpdateInfo.passengersApisIds);

            return returnPasUpdateInfo;

            function getAdditionalInfo (pasInfo, useForAll, isNeedUpdateAll) {
                const returnPasInfo = pasInfo.fieldStatus.frequentFlyer.isOpenPA ? { id: pasInfo.id } : { id: pasInfo.id, disruptionContact: { language: pasInfo.language || CheckinAppConstants.lang } };
                const needsToBeUpdated = (pasInfo.gender && pasInfo.gender !== 'CHILD' && pasInfo.gender !== pasInfo.initialData.contact.gender || pasInfo.fieldStatus.gender.mandatory || useForAll)
                    || (pasInfo.contactData.phone && pasInfo.contactData.phone.number && pasInfo.contactData.phone.number !== '' && (pasInfo.fieldStatus.contactData.mandatory || !angular.equals(pasInfo.contactData.phone, pasInfo.initialData.contact.phone) || useForAll))
                    || (pasInfo.contactData.email && pasInfo.contactData.email !== '' && (pasInfo.fieldStatus.contactData.mandatory || pasInfo.contactData.email !== pasInfo.initialData.contact.email || useForAll))
                    || (pasInfo.frequentFlyer.info && !angular.equals(pasInfo.frequentFlyer.info, pasInfo.initialData.contact.frequentFlyer.info));
                if ((needsToBeUpdated || isNeedUpdateAll) && pasInfo.gender && pasInfo.gender !== 'CHILD' && !pasInfo.fieldStatus.frequentFlyer.isOpenPA) {
                    returnPasInfo.gender = pasInfo.gender;
                }
                if ((needsToBeUpdated || isNeedUpdateAll) && pasInfo.contactData.phone && pasInfo.contactData.phone.number && pasInfo.contactData.phone.number !== '') {
                    returnPasInfo.disruptionContact.phone = pasInfo.contactData.phone;
                }
                if ((needsToBeUpdated || isNeedUpdateAll) && pasInfo.contactData.email && pasInfo.contactData.email !== '') {
                    returnPasInfo.disruptionContact.email = pasInfo.contactData.email;
                }
                if ((needsToBeUpdated || isNeedUpdateAll) && pasInfo.frequentFlyer.info && pasInfo.frequentFlyer.info.number !== '' && pasInfo.frequentFlyer.info.iataCompanyCode !== '') {
                    if (angular.equals(pasInfo.frequentFlyer.info, pasInfo.initialData.contact.frequentFlyer.info)) {
                        returnPasInfo.frequentFlyer = null;
                    } else {
                        returnPasInfo.frequentFlyer = pasInfo.frequentFlyer.info;
                    }
                }

                return needsToBeUpdated || isNeedUpdateAll ? returnPasInfo : null;
            }

            function getEmergencyInfo (pasInfo, useForAll, isNeedUpdateAll) {
                const dataRefused = {
                    refused: true,
                    name: 'REFUSED',
                    phone: {
                        countryCode: 'REFUSED',
                        number: 'REFUSED'
                    }
                };
                const returnEmerInfo = {
                    id: pasInfo.id,
                    emergencyContact: angular.copy(dataRefused)
                };
                const isOkPhone = angular.isObject(pasInfo.contactData.emergency.phone) && angular.isDefined(pasInfo.contactData.emergency.phone.number) && pasInfo.contactData.emergency.phone.number !== null && pasInfo.contactData.emergency.phone.number !== '';
                const isOkName = angular.isDefined(pasInfo.contactData.emergency.name) && pasInfo.contactData.emergency.name !== null && pasInfo.contactData.emergency.name !== '';
                const needsToBeUpdated = (isOkPhone && (pasInfo.fieldStatus.contactData.mandatory || useForAll || !angular.equals(pasInfo.contactData.emergency.phone, pasInfo.initialData.emergency.phone)))
                    || (isOkName && (pasInfo.fieldStatus.contactData.mandatory || useForAll || pasInfo.contactData.emergency.name !== pasInfo.initialData.emergency.name));
                let isNeedUpdate = needsToBeUpdated || isNeedUpdateAll;

                if(isNeedUpdate) {
                    if (isOkPhone && isOkName) {
                        isNeedUpdate = true;
                        returnEmerInfo.emergencyContact.refused = false;
                        returnEmerInfo.emergencyContact.phone = pasInfo.contactData.emergency.phone;
                        returnEmerInfo.emergencyContact.name = pasInfo.contactData.emergency.name;
                    }
                } else if (!isNeedUpdate && (!isOkPhone || !isOkName)) {
                    isNeedUpdate = true;
                    returnEmerInfo.emergencyContact = dataRefused;
                }

                return isNeedUpdate ? returnEmerInfo : null;
            }

            function getNewsLettersInfo (pasInfo) {
                const returnNewsLetterInfo = {
                    name: pasInfo.name,
                    firstSurname: pasInfo.surname,
                    email: pasInfo.contactData.email
                };
                return pasInfo.contactData.email && pasInfo.fieldStatus.contactData.show && !pasInfo.contactData.denyNewsLetter
                    ? returnNewsLetterInfo
                    : null;
            }

            function checkAdditionalInfo (passengers) {
                let isChanged = false;
                angular.forEach(passengers, (pas) => {
                    if (pas.isSelected) {
                        if (!angular.equals(pas.initialData.contact.email, pas.contactData.email) || !angular.equals(pas.initialData.contact.phone.number, pas.contactData.phone.number) ||
                            !angular.equals(pas.initialData.contact.frequentFlyer.info.iataCompanyCode, pas.frequentFlyer.info.iataCompanyCode) ||
                            !angular.equals(pas.initialData.contact.frequentFlyer.info.number, pas.frequentFlyer.info.number)) {
                            isChanged = true;
                        }
                    }
                });
                return isChanged;
            }

            function checkEmergencyInfo (passengers) {
                let isChanged = false;
                angular.forEach(passengers, (pas) => {
                    if (pas.isSelected) {
                        if (!angular.equals(pas.initialData.emergency.name, pas.contactData.emergency.name) || !angular.equals(pas.initialData.emergency.phone.number, pas.contactData.emergency.phone.number)) {
                            isChanged = true;
                        }
                    }
                });
                return isChanged;
            }
        }

        function getSegmentsUpdateInformation (segmentsInfo, selectedSegment) {
            let segmentIndex;
            const returnSegUpdateInfo = { selectedSegmentsIds: [], summaryTrip: '' };
            for (segmentIndex = 0; segmentIndex < segmentsInfo.length; segmentIndex++) {
                if (segmentsInfo[segmentIndex].isSelected && !selectedSegment) {
                    returnSegUpdateInfo.selectedSegmentsIds.push(parseInt(segmentsInfo[segmentIndex].id));
                    returnSegUpdateInfo.summaryTrip += (returnSegUpdateInfo.summaryTrip.length > 0 ? '-' : '') + segmentsInfo[segmentIndex].departure.airportCode + '-' +
                        segmentsInfo[segmentIndex].arrival.airportCode;
                } else if (selectedSegment && returnSegUpdateInfo.selectedSegmentsIds.length === 0) {
                    returnSegUpdateInfo.selectedSegmentsIds.push(parseInt(selectedSegment.id));
                    returnSegUpdateInfo.summaryTrip += (returnSegUpdateInfo.summaryTrip.length > 0 ? '-' : '') + selectedSegment.departure.airportCode + '-' +
                        selectedSegment.arrival.airportCode;
                }
            }
            return returnSegUpdateInfo;
        }

        function getAcceptUpdateInformation (selectedSegments, passengers) {
            let segmentIndex;
            const requestAcceptInfo = { dangerousItemsInfoAccepted: true, segments: [] };
            for (segmentIndex = 0; segmentIndex < selectedSegments.length; segmentIndex++) {
                requestAcceptInfo.segments[segmentIndex] = { id: selectedSegments[segmentIndex], passengers: passengers };
            }
            return requestAcceptInfo;
        }

        function updateSelectedSegments (segments, uncheckAbleSegments) {
            let segmentIndex;
            const acceptedSegments = [];
            for (segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                if (uncheckAbleSegments.indexOf(segments[segmentIndex]) === -1) {
                    acceptedSegments.push(segments[segmentIndex]);
                }
            }
            return acceptedSegments;
        }

        function updateSelectedPassengers (selectedPassengers, responsePassengers) {
            let passengerIndex;
            const updatedPassengers = [];
            for (passengerIndex = 0; passengerIndex < responsePassengers.length; passengerIndex++) {
                if (selectedPassengers.indexOf(responsePassengers[passengerIndex]) !== -1) {
                    updatedPassengers.push(selectedPassengers[i]);
                }
            }
            return updatedPassengers;
        }

        function initModelApisUsTracing () {
            const ckeckApisUsTracing = {
                show: false,
                CHECK_US_PRIVACY_ACT_STATEMENT: 'CHECK_US_PRIVACY_ACT_STATEMENT',
                checkPrivacyText: ''
            };

            return ckeckApisUsTracing;
        }

        function checkExistAPIsUsTracing (modelApisUsTracing, isRequiredEmergencyData) {
            const tagsInfo = {
                link1: {
                    tag: 'a',
                    title: 'link',
                    class: 'ib-link ib-link--important ib-link--underline',
                    id: 'us_tracing'
                }
            };
            let btn;

            // control apis + mandatory emergency data
            modelApisUsTracing.show = isRequiredEmergencyData;

            if (modelApisUsTracing.show) {
                modelApisUsTracing.checkPrivacyText = $sce.trustAsHtml($filter('literalFormatter')($filter('translate')(modelApisUsTracing.CHECK_US_PRIVACY_ACT_STATEMENT), tagsInfo));
                localStorageService.set('usTracing', true);
                $timeout(() => {
                    btn = angular.element('#us_tracing');
                    btn.on('click', () => {
                        openUsPrivacyActStatementModal();
                    });
                });
            }

            return modelApisUsTracing;
        }

        function openUsPrivacyActStatementModal () {
            const tagsInfo = {
                bold: {
                    tag: 'span',
                    class: 'ib-message-box__text--bold'
                },
                p: {
                    tag: 'p',
                    class: 'ib-text u-mt'
                }
            };
            const modelModal = {
                title: {
                    message: 'MODAL_US_PRIVACY_ACT_STATEMENT_TITLE',
                    needsTranslate: true
                },
                message: '',
                needsTranslate: false
            };

            modelModal.message = $filter('literalFormatter')($filter('translate')('MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P1'), tagsInfo);
            modelModal.message += $filter('literalFormatter')($filter('translate')('MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P2'), tagsInfo);
            modelModal.message += $filter('literalFormatter')($filter('translate')('MODAL_US_PRIVACY_ACT_STATEMENT_BODY_P3'), tagsInfo);
            modelModal.message = $sce.trustAsHtml(angular.copy(modelModal.message));
            ModalService.showGenericModal(modelModal, false,'ib-info-modal-us-privacy');
        }

        function  getReasonNoItemInhibition (reason) {
            let item = null;
            reason = Array.isArray(reason) ? reason : [];
            if (reason.includes(CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.RESI_REASON)) {
                item = CheckinAppConstants.ITEMS_TYPES.RESI;
            } else if (reason.includes(CheckinAppConstants.INHIBIT_BOARDING_CARD_TYPES.SEE_AGENT_REASON)) {
                item = CheckinAppConstants.ITEMS_TYPES.SEE_AGENT;
            }

            return item;
        }

        function getPassengerStatusReason(passengerStatus) {
            if (!passengerStatus.reason) {
                return '';
            }

            const reasonData = passengerStatus.reason;

            const inhibitItems = {
                RESI: 'EARLY_CKI_INHIBIT_MODAL_MESSAGE_RESI',
                AVIH: 'EARLY_CKI_INHIBIT_MODAL_MESSAGE_AVIH_PETC',
                PETC: 'EARLY_CKI_INHIBIT_MODAL_MESSAGE_AVIH_PETC',
                UMNR: 'EARLY_CKI_INHIBIT_MODAL_MESSAGE_UMNR',
                COUR: 'EARLY_CKI_INHIBIT_MODAL_MESSAGE_COUR',
            };

            const reasonDataItem = reasonData?.code?.includes('ECKI_PASSENGER_ITEM_NOT_ALLOWED') && reasonData.code.split('_').at(-1);

            if (!inhibitItems[reasonDataItem]) {
                return passengerStatus.reason.message ?? '';
            }

            return $filter('translate')(inhibitItems[reasonDataItem]);
        }
    }
})();
